const colors = {
  violet: "#4834d4",
  black: "#130F40",
  black2: "#2c3e50b3",
  white01: "#ecf0f1",
  gray: "#a8a8a8",
  citylight: "#dfe6e9",
  green: "#2ecc71",
  blue: "#3498db",
};

export default colors;
